package com.ragnorak.clanybackoffice.ui.screens

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import dev.zacsweers.metro.Inject
import com.clany.backoffice.domain.usecase.GetDashboardMetricsUseCase
import com.clany.backoffice.model.DashboardMetrics
import kotlinx.coroutines.launch

data class DashboardUiState(
    val isLoading: Boolean = false,
    val metrics: DashboardMetrics? = null,
    val error: String? = null
)

class DashboardViewModel @Inject constructor(
    private val getDashboardMetricsUseCase: GetDashboardMetricsUseCase
) : ViewModel() {

    var uiState by mutableStateOf(DashboardUiState())
        private set

    init {
        loadMetrics()
    }

    fun loadMetrics() {
        viewModelScope.launch {
            uiState = uiState.copy(isLoading = true, error = null)
            getDashboardMetricsUseCase()
                .onSuccess { metrics ->
                    uiState = uiState.copy(isLoading = false, metrics = metrics)
                }
                .onFailure {
                    uiState = uiState.copy(isLoading = false, error = it.message)
                }
        }
    }
}
